<template>
  <div v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_PURCHASE_ORDER_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu đặt hàng</h1>
      <div class="float-right btn-group">
        <button
          v-if="dataPermission && dataPermission.includes('CNPS_DEVICE_PURCHASE_ORDER_EXPORT')"
          @click="exportExcel"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.billNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Mã đơn hàng"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.receiptOrderCode"
              class="form-control f12 hc-37 text-search"
              placeholder=" Mã phiếu thu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :settings="searchAgent"
              placeholder="Người tạo"
            ></Select2>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.agentId"
              :settings="searchAgent"
              placeholder="Đơn vị nhận"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.regionId" :options="dataRegion" placeholder="Vùng"> </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="optionStatus"
              :settings="{ placeholder: 'Trạng thái' }"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.keeperId"
              :options="listKeeper"
              :settings="{ placeholder: 'Người phụ trách' }"
            >
            </Select2>
          </div>

          <div class="form-group">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="resetFilters"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="mb-3">Tổng: {{ pagination?.total || 0 }}</div>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="list"
              :fields="tableFields"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data?.index) }}
              </template>

              <template #cell(createdTime)="data">
                <p v-if="data?.item?.createdTimeStr">
                  {{ data?.item?.createdTimeStr }}
                </p>
              </template>
              <template #cell(status)="data">
                <span
                  style="color: white"
                  class="badge"
                  :class="transformDataColor(data?.item?.status, optionStatus)"
                >
                  {{ data?.item?.status | transformData(optionStatus) }}
                </span>
              </template>
              <template #cell(orderTransferStatus)="data">
                <span
                  style="color: white"
                  class="badge"
                  :class="
                    transformDataColor(data?.item?.orderTransferStatus, Config.statusWarehouse)
                  "
                >
                  {{ data?.item?.orderTransferStatus | transformData(Config.statusWarehouse) }}
                </span>
              </template>
              <template #cell(receiptOrderStatus)="data">
                <span
                  class="badge"
                  :class="`badge-${transformDataColor(data?.item?.receiptOrderStatus, Config.statusTranferAgent)}`"
                >
                  {{ data?.item?.receiptOrderStatus | transformData(Config.statusTranferAgent) }}
                </span>
              </template>

              <template #cell(keeper)="{ item }">
                <span>
                  {{ item?.keeper?.name }}
                  <br />
                  {{ item?.keeper?.email }}
                </span>
              </template>

              <template #cell(totalQuantity)="data">
                {{ calculateTotalQuantity(data?.item?.orderDetail) }}
              </template>

              <template #cell(action)="{ item }">
                <a
                  target="_blank"
                  class="btn btn-link btn-sm mr-2 text-primary"
                  :href="`/order-form-detail/${item?.id}`"
                >
                  Chi tiết
                </a>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom px-4">
        <b-pagination
          v-model="search.page"
          :total-rows="pagination?.total"
          :per-page="search?.limit"
          class="mr-2"
        ></b-pagination>
      </div>
    </div>
    <ModalExportNoti ref="uploadNotif" />
  </div>
</template>

<script>
  import moment from 'moment'
  import Config from '@/thirdParty/config'
  import { CommonService } from '@/services/common.service'
  import { DeviceService } from '@/services/device.service'
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import { showMessErrorResponse, showMessError } from '@/config/utils.js'

  const tableFields = [
    { key: 'index', label: 'STT' },
    { key: 'orderCode', label: 'Mã phiếu' },
    { key: 'receiptOrderCode', label: 'Mã phiếu thu' },
    { key: 'createdTimeStr', label: 'Ngày tạo' },
    { key: 'userCreator.name', label: 'Người tạo' },
    { key: 'agentName', label: 'Đơn vị nhận' },
    { key: 'keeper', label: 'Người phụ trách' },
    { key: 'totalQuantity', label: 'Tổng SL' },
    { key: 'regionName', label: 'Vùng' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'orderTransferStatus', label: 'Trạng thái điều chyển' },
    { key: 'receiptOrderStatus', label: 'Trạng thái phiếu thu' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  const dataUser = JSON.parse(localStorage.getItem('userData'))
  export default {
    name: 'OderFormCtv',
    components: {
      ModalExportNoti,
    },
    data() {
      return {
        localeData: Config.localeData,
        loading: false,
        showLoading: false,
        tableFields,
        optionCreators: [],
        optionInventory: [],
        optionStatus: [{ id: '0', text: 'Tất cả', variant: '' }, ...Config.satusOderForm],
        dataRegion: [],
        list: [],
        search: {
          page: 1,
          limit: 20,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        listKeeper: [],
        dataUser,
        searchAgent: {
          ajax: {
            delay: 500,
            transport: (params, success, failure) => {
              const txtSearch = params.data?.q?.trim() || ''
              // if (!txtSearch) {
              //   return success({
              //     results: [],
              //   })
              // }
              if (this.tLoadOwner) {
                clearTimeout(this.tLoadOwner)
              }
              this.tLoadOwner = setTimeout(() => {
                CommonService.getListAgentBank({
                  keyword: txtSearch,
                }) // AI
                  .then(res => {
                    success({
                      results:
                        res.data?.map(item => {
                          return {
                            id: item?.agentId,
                            text: item.name || '',
                          }
                        }) || [],
                    })
                  })
                  .catch(failure)
              }, 500)
            },
          },
        },
        pagination: {
          total: 0,
        },
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    created() {
      this.fetchData()
      this.getRegions()
      this.fetchSubordinate()
    },

    watch: {
      'search.limit': function () {
        this.fetchData()
      },
      'search.page': function () {
        this.fetchData()
      },
    },

    methods: {
      async fetchSubordinate() {
        try {
          const res = await StaffService.getStaffByIdSuperior({ userId: this.dataUser.userId })
          if (res.code === 1000) {
            this.listKeeper = res.data.map(item => {
              return { id: item.userId, text: `${item.name} - ${item.userName}` }
            })
          } else {
            showMessError(this, res.message)
          }
        } catch (error) {
          showMessErrorResponse(this, error)
        }
      },

      async exportExcel() {
        try {
          const body = {
            object: this.search,
            type: 'CNPS_DEVICE_PURCHASE_ORDER',
          }
          const data = await CommonService.receiveFile(body)
          if (data.success) {
            this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          console.log(error)
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },

      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataRegion = data.data.map(e => {
            return { id: e.id, text: e.name, region: e.id }
          })
        }
      },
      calculateTotalQuantity(orderDetail) {
        if (!orderDetail || !Array.isArray(orderDetail)) return 0
        return orderDetail.reduce((sum, item) => sum + (item.quantity || 0), 0)
      },

      transformDataColor(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].bgColor || dataReturn[0].color || ''
      },

      transformDate() {
        if (this.dateRange.startDate && this.dateRange.endDate) {
          this.search.dateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
          this.search.dateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
        } else {
          delete this.search.dateFrom
          delete this.search.dateTo
        }
      },

      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        await this.fetchData()
      },

      async resetFilters() {
        this.search = {
          page: 1,
          limit: 20,
          sortResultList: [
            {
              direction: 'DESC',
              field: 'createdDate',
            },
          ],
          projectionList: [],
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },

      viewDetails(id) {
        this.$router.push(`/order-form-detail/${id}`)
      },

      formatDateTime(dateString) {
        if (!dateString) return 'N/A'
        const date = new Date(dateString)
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()

        return `${hours}:${minutes}, ${day}/${month}/${year}`
      },

      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },

      async fetchData() {
        if (!this.loading) this.showLoading = true
        try {
          this.loading = true

          // Chuẩn bị dữ liệu request theo interface mới
          const requestParams = {
            ...this.search,
          }

          // Gọi API với tham số mới
          const response = await DeviceService.getListOrderForm(requestParams)

          if (response.code === 1000) {
            this.list = response.data || []
            this.pagination.total = response?.totalPage?.total || 0
          } else {
            this.list = []
            this.pagination.total = 0
          }
        } catch (error) {
          console.error('Error fetching data:', error)
          this.list = []
          this.pagination.total = 0
        } finally {
          this.loading = false
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .pagination-bottom {
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
  }
</style>
